import { useContext } from "react";

import { MeetingContext } from "./MeetingContext";

export function useMeeting() {
  const context = useContext(MeetingContext);
  if (!context) {
    throw new Error("useMeeting must be used within a MeetingProvider");
  }
  return context;
}
